module.exports = __webpack_public_path__ + "img/noti-logo.0de68348.svg";